export { default as FourHundredError } from './FourHundredError';
export type { FourHundredErrorProps } from './FourHundredError';
export { default as FourHundredErrorPage } from './FourHundredErrorPage';
